import { ClosingOffer, GetClosingOfferInput } from '@buy-viasat/types/build/bv';
import api, { apiEndpoints } from '../../../services/axios';

export async function getClosingOfferRest(input: GetClosingOfferInput): Promise<ClosingOffer> {
  const { location, rootProductId, salesAgreementId, productIds } = input;
  const { address, coordinates } = location;

  if (!address || coordinates?.latitude == null || coordinates?.longitude == null) {
    throw new Error('getClosingOfferRest: missing address or coordinates');
  }

  const body = {
    closingOfferId: productIds[0],
    rootProductTypeId: rootProductId,
    salesAgreementId,
    addressLines: address.addressLines,
    municipality: address.municipality,
    region: address.region,
    postalCode: address.postalCode,
    countryCode: address.countryCode,
    latitude: String(coordinates.latitude),
    longitude: String(coordinates.longitude),
  };

  const response = await api.post(apiEndpoints.getClosingOffer, body);
  return response.data;
}
